import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./GuardianesInvitation.module.css";
import MarineJellyfish from "./Auth/MarineJellyfish";

interface GuardianesInvitationProps {
  open: boolean;
  onClose: () => void;
}

export default function GuardianesInvitation({ open, onClose }: GuardianesInvitationProps) {
  const navigate = useNavigate();
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!open) return;
    closeButtonRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose, open]);

  if (!open) return null;

  const startGame = () => navigate("/guardianes-de-protea");

  return (
    <div className={classes.backdrop} role="presentation" onMouseDown={(event) => {
      if (event.currentTarget === event.target) onClose();
    }}>
      <section
        className={classes.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="guardianes-invitation-title"
        aria-describedby="guardianes-invitation-description"
      >
        <div className={classes.art} aria-hidden="true">
          <MarineJellyfish interactive={false} className={classes.invitationJellyfish} />
        </div>
        <p className={classes.eyebrow}>Huevo de pascua descubierto</p>
        <h2 id="guardianes-invitation-title">¿Nos ayudás a cuidar el mar?</h2>
        <p id="guardianes-invitation-description">Un pequeño gesto también cuida el mar.</p>
        <div className={classes.actions}>
          <button type="button" className={classes.primaryButton} onClick={startGame}>Jugar</button>
          <button ref={closeButtonRef} type="button" className={classes.secondaryButton} onClick={onClose}>Ahora no</button>
        </div>
      </section>
    </div>
  );
}
